import React from 'react'

interface Props {}

const MyCart: React.FC<Props> = () => {
  return <div>MyCart</div>
}

export default MyCart
